import React from "react";
import { Constants } from "../../../../CommonMethhods/Constants";

function PayinDetailsTable() {
  return (
    <thead>
      <tr>
        <th scope="col">{Constants.Date_and_Time}</th>
        <th scope="col" className="text-center">
          {Constants.Amount}
        </th>
        <th scope="col" className="text-center">
          {Constants.Status}
        </th>
        <th scope="col" className="text-center">
          {Constants.Payment_Mode}
        </th>
        <th scope="col" className="text-center">
          {Constants.Bank_Account}
        </th>
        <th scope="col" className="text-center">
          {Constants.Transaction_Id}
        </th>
      </tr>
    </thead>
  );
}
export default PayinDetailsTable;
